import { post, put } from '../../lib/wfApi'

export const CREATE_DEAL = 'CREATE_DEAL'
export const CREATE_DEAL_SUCCESS = 'CREATE_DEAL_SUCCESS'
export const CREATE_DEAL_FAILURE = 'CREATE_DEAL_FAILURE'
export const EDIT_DEAL = 'EDIT_DEAL'
export const EDIT_DEAL_SUCCESS = 'EDIT_DEAL_SUCCESS'
export const EDIT_DEAL_FAILURE = 'EDIT_DEAL_FAILURE'
export const FORM_RESET = 'FORM_RESET'
export const UPDATE_FIELD_DATA = 'UPDATE_FIELD_DATA'

function createDealRequest() {
  return {
    type: CREATE_DEAL
  }
}

function createDealSuccess() {
  return {
    type: CREATE_DEAL_SUCCESS
  }
}

function createDealFailure(error) {
  return {
    type: CREATE_DEAL_FAILURE,
    payload: error
  }
}

function editDealRequest() {
  return {
    type: EDIT_DEAL
  }
}

function editDealSuccess() {
  return {
    type: EDIT_DEAL_SUCCESS
  }
}

function editDealFailure(error) {
  return {
    type: EDIT_DEAL_FAILURE,
    payload: error
  }
}

export function formReset() {
  return {
    type: FORM_RESET
  }
}

export function updateFieldData(data) {
  return {
    type: UPDATE_FIELD_DATA,
    payload: data
  }
}

export const setErrorMessage = (errors) => {
  return dispatch => dispatch(editDealFailure(errors))
}

export const createDeal = (data) => {
  return dispatch => {
    dispatch(createDealRequest())
    return post('deals', JSON.stringify(data))
      .then(response => {
        return response.json()
      })
      .then(data => {
        if (data.errors && Object.keys(data.errors).length) { 
          dispatch(createDealFailure(data.errors))
        } else {
          dispatch(createDealSuccess())
        }
      })
      .catch(() => dispatch(createDealFailure({error: 'Error'})))
  }
}

export const editDeal = (id, data) => {
  return dispatch => {
    dispatch(editDealRequest())
    return put(`deals/${id}`, JSON.stringify(data))
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (response.ok) {
          dispatch(editDealSuccess())
        } else {
          dispatch(editDealFailure(response.errors))
        }
      })
      .catch(() => dispatch(editDealFailure({error: 'Error'})))
  }
}